

/* //const TipoRuta = process.env.NODE_ENV === 'production' ? true : false;  // true: produccion  desarrollo / : 
 */    //console.log(process.env.NODE_ENV);
const TipoRuta = true; //

const globales = () => {

    if (TipoRuta) {
        // PRODUCCION HACIA FUERA
        return {

            URLAPI: 'https://www.pch.cl/InfoComApi/api/',
            URLAPISUCA: 'https://www.pch.cl/SucaApi/',
            URLAPISUPER: 'https://www.pch.cl/InfoComXApi/',
            urlQrPDF: 'https://api.qrserver.com/v1/create-qr-code/?data=https://www.pch.clValidador/&amp;size=50x50"',
            urlLink: 'https://www.pch.clValidador/',
            applicationId: 71,
            productIdEeff: 8,// antes en 0
            productId: 8,
            URLTIPOCONTRATOIDINFOCOM: [3,22,23],
            URLTIPOCONTRATOIDONP: 8,
            rutaServidor: '/'

        }

    } else {
        // DESARROLLO DESDE ADENTRO DE LA OFICINA
        return {

            URLAPI: 'https://192.168.19.9/InfoComApi/api/',
            URLAPISUCA: 'https://192.168.19.9/SucaApi/',
            URLAPISUPER: 'https://192.168.19.9/InfoComXApi/',
            urlQrPDF: 'https://api.qrserver.com/v1/create-qr-code/?data=https://192.168.19.9Validador/&amp;size=50x50"',
            urlLink: 'https://192.168.19.9Validador/',
            applicationId: 71,
            productIdEeff: 8, // antes en 0
            productId: 8,
            URLTIPOCONTRATOIDINFOCOM: [3,22,23],
            URLTIPOCONTRATOIDONP: 8,
            rutaServidor: '/'

        }

    }




}

const mensajeglobales = () => {

    return {


        MSG_ERROR_401: 'Debes de iniciar sesión para realizar la consulta (INFORMECOMERCIAL-ERROR 401)',
        MSG_ERROR_AUTORITETIONS_401: 'Atención, usted no tiene autorización (CONSULTE A SOPORTE)',
        MSG_ERROR_CONSULTE_SOPORTE: 'hubo un error, por favor contactese con soporte',
        MSG_ERROR_RUT_VALIDO: 'Debes de indicar un  RUT VALIDO (INFORMECOMERCIAL-ERROR RUT)',
        MGS_SIN_RESULTADO_INFORME: 'Atención, No se han encontrado resultado verifique e intente de nuevo (INFORMECOMERCIAL)',
        MSG_ERROR_CREDENCIALES_LOGIN: 'Atención sus credenciales de acceso no son validas (AUTENTICACIÓN NO VALIDAD):',
        MSG_ERROR_SOLICITUD_INTENTE_NUEVO: 'Error al procesar su solicitud, inténtelo mas tarde',
        MSG_ENVIADO_CON_EXITO: 'Se ha enviado su mensaje con exito',
        MSG_NO_TIENE_PRODUCTO_ASOCIADO: 'El usuario no tiene el producto asociado (CONSULTE A SOPORTE)',
        MSG_TRAFICO_RED_CONGESTIONADO: 'Su tráfico de Red está congestionado, favor intente nuevamente.',




    }

}

export { globales, mensajeglobales };



